<template>
    <ProSpaceHLayout :gap="5" class="home-dashboard-grouping" is-inline-h>
        <ProSpaceIcon :icon="icon" type="secondary" />
        <div class="text-color-main text-bold text-size-13">
            {{ text }}
        </div>
    </ProSpaceHLayout>
</template>

<script>
import {
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceIcon
} from "@prospace/prospace-components-library";
export default {
    name: "HomeDashboardGrouping",
    components: {
       ProSpaceHLayout,
        ProSpaceVLayout,
        ProSpaceIcon
    },
    props: {
        icon: {
            type: String,
            default: 'parameters'
        },
        text: {
            type: String,
            required: true
        },
        valueGroup: {
            type: String,
            required: true
        }
    },
}
</script>

<style lang="scss">
.home-dashboard-grouping {
    padding: 5px 10px;
    box-shadow: 0px 2px 10px rgba(51, 51, 51, 0.07);
    cursor: pointer;
    margin: 0 10px;
    width: calc(100% - 20px) !important;
    @media screen and (max-height: 800px) {
        padding: 0px 10px;
        min-height: 30px !important;
    }
}
</style>
